import React, { ReactElement } from 'react';
import styles from './Menu.module.css';

const MenuItemDivider = (): ReactElement => {
  return <div className={styles.divider} />;
};

export default MenuItemDivider;
